import React from 'react'

import {QuantityStep} from '../../../../shared/order-editor/components/fields/Quantity'

/**
 * OrderIntake-specific wrapper for QuantityStep.
 * Uses default configuration without any custom parameters.
 * This component is used in the order intake flow where all fields
 * are freely editable without approval requirements.
 */
export const OrderIntakeQuantityStep: React.FC = () => {
  return <QuantityStep />
}
